import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import InfluencerDashboard from "./components/InfluencerDashboard";
import Registration from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import AdminDashboard from "./components/AdminDashboard";
import ConfirmationPage from "./components/UnifiedPay/ConfirmationPage";
import CheckoutPage from "./components/UnifiedPay/CheckoutPage";
import StripeWrapper from "./components/UnifiedPay/PaymentForm";
import BulkUserImport from "./components/UnifiedPay/BulkUserImport";
import StripeWrapperUs from "./components/UnifiedPay/PaymentFormUs";


const App = () => {
  return (
    <div>
    <Router>
      <Routes>
        <Route path="/" element={<StripeWrapper />} />
        <Route path="/us-cad" element={<StripeWrapperUs />} />
        <Route path="/access" element={<BulkUserImport />} />
        <Route path="/dashboard" element={<InfluencerDashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
         <Route path="/checkout" element={<CheckoutPage />} />
         <Route path="/register" element={<Registration />} />
        {/* 
        <Route path="/dashboard" element={<InfluencerDashboard />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/lead/:referralId" element={<LeadCollection />} /> */}
       
      </Routes>
    </Router>
    </div>
  );
};

export default App;
